module.exports = __webpack_public_path__ + "chelsea-6c03ec15048f88513999b23e81eb312b.png";